import { render, staticRenderFns } from "./hyperlink.vue?vue&type=template&id=2647eccc&"
import script from "./hyperlink.vue?vue&type=script&lang=js&"
export * from "./hyperlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports